import React, { Fragment, useEffect, useRef } from "react"
import { Container, Row, Col } from "reactstrap"
import { isBrowser } from 'react-device-detect';
import Footer from '../../container/Footer'
import Header from '../../container/Header';
import ProfileList from "../../container/ProfileList";

const ProfileTab = (metadata) => {
    const getMobileView = () => {
        return (
            <div>My Profile</div>
        )
    }

    const getBrowserView = () => {
        return (
            <Row noGutters className="pt-2 pt-md-5 w-100 px-4 px-xl-0 mb-3 position-relative">
                <Col key={1} xs={{ order: 1 }} md={{ size: 12, order: 1 }} tag="section"
                    className="py-5 mb-5 py-md-0 mb-md-0">
                        <ProfileList />
                    </Col>
            </Row>

        )
    }

    const getView = () => {
        return isBrowser ? getBrowserView() : getMobileView();
    }

    return (
        <Container className="px-0">
            <Header />
            {getView()}
            <Footer />
        </Container>
    )
}

export default ProfileTab;